const EURegionCodes = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'GB',
];

export function getIdvVendor(region?: string): string | undefined {
  if (!region) {
    return undefined;
  }

  if (EURegionCodes.includes(region)) {
    return 'onfido';
  }

  if (['NZ', 'AU'].includes(region)) {
    return 'incode';
  }

  return undefined;
}
